import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import Keycloak from 'keycloak-js';

async function checkLogin() {
  const keycloak = inject(Keycloak);
  const loggedIn = keycloak.authenticated;
  if (!loggedIn) {
    await keycloak.login();
    return false;
  }
  return true;
}

export const authGuard: CanActivateFn = checkLogin;
